import axios from "axios";
import store from "./store";
import { getToken } from './Helpers/LocalStorage';
import { LOGOUT } from "./actions/Types";

axios.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${JSON.parse(token)}`;
        }
        config.headers['Content-Type'] = 'application/json';
        return config;
    },
    error => {
        return Promise.reject(error)
    });
axios.interceptors.response.use(
    response => {
        return response;
    },
    (error) => {
        console.log("Error Status", error.response);
        const { status } = error.response;
        if (status === 401) {
            store.dispatch({ type: LOGOUT });
        }
        return Promise.reject(error)
    });
